moduleViewApp.filter('filterItemTypes', [->
  (input, type) ->
    _.filter input, (item) ->
      switch type.slug
        when "all"
          true
        else
          item.template_type == type.slug
])

moduleViewApp.controller('showSetCtrl', ['$scope', '$window', '$location', '$routeParams', '$q', 'DebugHelper', 'myPartnersService', 'PassageHighlightingService', 'MySetsResource', 'SetsResource', 'V3SetItemsResource', 'SiteNavigationService', 'ScormPackagesResource', 'moduleContextService', 'ModulePermissionsHelper', 'setLearnURLService', ($scope, $window, $location, $routeParams, $q, DebugHelper, myPartnersService, PassageHighlightingService, MySetsResource, SetsResource, V3SetItemsResource, SiteNavigationService, ScormPackagesResource, moduleContextService, ModulePermissionsHelper, setLearnURLService) ->
  DebugHelper.register('showSetCtrl', $scope)

  bootstrapData = angular.element("#module--container").data()

  watchers = []

  _.assignIn $scope,
    uiState: {}
    defaultGoalImage: bootstrapData.defaultGoalImage
    defaultUserImage: bootstrapData.defaultUserImage
    defaultDescription: "js.module_view.show_set.default_description"
    set: {}
    items: []
    remixItemsToDelete: []
    routes: Packs.iKnowRoutes
    showMemoryBank: false
    itemsLoaded: false
    creatorPath: ""
    returnURL: $window.location.pathname
    drawMemoryBank: false
    SiteNavigationService: SiteNavigationService
    itemTypes: [
      slug: "all"
      text: "js.module_view.show_set.item_types.all"
    ,
      slug: "association_collection"
      text: "js.module_view.show_set.item_types.associations"
    ,
      slug: "vocabulary"
      text: "js.module_view.show_set.item_types.vocabulary"
    ,
      slug: "cloze_container"
      text: "js.module_view.show_set.item_types.cloze_container"
    ,
      slug: "image_map"
      text: "js.module_view.show_set.item_types.image_map"
    ,
      slug: "sequence"
      text: "js.module_view.show_set.item_types.sequence"
    ,
      slug: "pattern"
      text: "js.module_view.show_set.item_types.pattern"
    ,
      slug: "instructional_content"
      text: "js.module_view.show_set.item_types.instructional_items"
    ,
      slug: "application_question"
      text: "js.module_view.show_set.item_types.application_question"
    ,
      slug: "question_and_answer"
      text: "js.module_view.show_set.item_types.question_and_answer"
    ]

    getPreviewUrl: ->
      setLearnURLService.getUrl({id: $scope.set.id, version: $scope.set.learn_version}, { studyType: 'all', preview: true, debug: true, returnURL: $scope.returnURL })

    canEditRemixed: ->
      SiteNavigationService.isCreate() && ModulePermissionsHelper.canEditModuleInPartnerContext($scope.set)

    canEditSet: ->
      !$scope.set.remixed_only && $scope.canEditRemixed() && !$scope.set.scorm_package_id

    registerAndLaunchScorm: ->
      $scope.uiState.launchPending = true
      MySetsResource.addToLibrary
        id: $scope.set.id
      , (success) ->
        $scope.getLinkAndLaunch(false)
      , (error) ->
        $scope.uiState.launchPending = false

    getLinkAndLaunch: (preview = true) ->
      $scope.uiState.launchPending = true
      if !$scope.set.scorm_package_id # should never reach this
        DebugHelper.logError("Launch link request attempted for set" + $scope.set.id + " without scorm package id")
        $scope.uiState.launchPending = false
        return
      ScormPackagesResource.get_launch_link
        id: $scope.set.scorm_package_id
        preview: preview
      , (success) ->
        $window.open(success.response, "_blank")
        $scope.uiState.launchPending = false
      , (error) ->
        DebugHelper.logError('Unexpected error ' + error + ' getting launch link')
        $scope.uiState.launchPending = false
        
    saveSet: (params) ->
      SetsResource.update { id: $routeParams.set_id }, params

    pushRemixItemsToDelete: (item) ->
      $scope.remixItemsToDelete.push(item.id)
      item.deleted = true
      $scope.shouldPromptItemsDelete = true

    undoRemixItemsToDelete: (item) ->
      $scope.remixItemsToDelete = _.reject $scope.remixItemsToDelete, (id) -> id == item.id
      item.deleted = false

    confirmDeleteRemixItems: ->
      promises = _.map $scope.remixItemsToDelete, (itemId) ->
        V3SetItemsResource.delete
          set_id: $scope.set.id
          id: itemId
        .$promise

      $q.allSettled(promises).then (results) ->
        $scope.deletedItems = _.filter $scope.items, (item) ->
          _.includes($scope.remixItemsToDelete, item.id)
        $scope.items = _.reject $scope.items, (item) ->
          _.includes($scope.remixItemsToDelete, item.id)

        facet_counts = _.map($scope.deletedItems, (item) -> item[item.template_type].facets.length)
        memories_deleted = _.reduce(facet_counts, (memo, num) ->
          memo + num
        , 0)
        $scope.set.memories_count = $scope.set.memories_count - memories_deleted
        $scope.remixItemsToDelete = []
        $scope.stickyFlashMessage = "js.module_view.show_set.remix_delete"

    fetchSet: ->
      moduleContextService.fetchModule($routeParams.set_id, 'set').then (module) ->
        $scope.set = module
        SiteNavigationService.setContext($scope.set, 'set')

        if $routeParams.course_id
          SiteNavigationService.setCourseId($routeParams.course_id)
        $scope.canEdit = $scope.canEditSet()
        SiteNavigationService.can_edit = $scope.canEdit

        # quick and dirty reroute hits to create/sets to create/sets/:id/edit_details if we know it doesn't have items
        if $scope.set?.scorm_package_id && ($location.path() == Packs.iKnowRoutes.v2_create_set_path($scope.set.id) || $location.path() == Packs.iKnowRoutes.edit_v3_create_set_path($scope.set.id))
          $location.path Packs.iKnowRoutes.edit_details_v2_create_set_path($scope.set.id)

        $scope.canDeleteRemix = $scope.canEditRemixed()

        if myPartnersService.showPartnerModuleDetails()
          $scope.ltiStudyPath = $scope.ltiStudyPathForSet($scope.set)
        $scope.publicModulePath = $window.location.protocol + "//" + $window.location.host + Packs.iKnowRoutes.v3_learn_set_path($scope.set.id)
        if !$scope.set.settings
          $scope.set.settings = {}

        watchers.push $scope.$watch "set.image.id", (newVal, oldVal) ->
          if $scope.set.image && (newVal != oldVal)
            $scope.saveSet { icon_image_id: $scope.set.image.id }

        watchers.push $scope.$watch "set.privacy_type.id", (newVal, oldVal) ->
          if !_.isUndefined(oldVal) && $scope.set.privacy_type && (newVal != oldVal)
            $scope.saveSet { privacy_type_id: $scope.set.privacy_type.id }

        # clear the watchers to prevent double binds after reload
        $scope.$on "$destroy", ->
          for w in watchers
            w()

        $scope.creatorPath = ""

        if $scope.set.parent_set_id
          $scope.adaptedFromPath = Packs.iKnowRoutes.v3_learn_set_path($scope.set.parent_set_id)

        if $scope.set.remixable_type
          $scope.remixed = true

    ltiStudyPathForSet: (set) ->
      urlPrefix = $window.location.protocol + "//" + $window.location.host
      v3LtiStudyPath = urlPrefix + '/lti/study/' + set.id
      v4LtiStudyPath = urlPrefix + "/lti/app/learn/sets/#{set.id}"
      if set.learn_version == 4
        v4LtiStudyPath
      else
        v3LtiStudyPath

    passageWithHighlights: (item) ->
      nodes = _.map item.cloze_container.facets, (f) -> f.anchor.cloze_node
      PassageHighlightingService.passageWithHighlights(nodes, item.cloze_container.text)

    setItemTypeFilter: (itemType) ->
      $scope.itemTypeFilter = itemType

  $scope.itemMode = $routeParams.itemMode || "view"
  $scope.itemTypeFilter = $scope.itemTypes[0]

  myPartnersService.initialize().then () ->
    $scope.fetchSet()

  $scope.$on "moduleDropDown:delete", (event, removedId, moduleType) ->
    $location.path Packs.iKnowRoutes.v2_sets_path()

  # TODO: bind only to item editor fancy box
  angular.element($window).bind 'afterClose', ->
    $scope.fetchSet()
])
